<form
  class="credit-card-form"
  [formGroup]="cardForm"
  (submit)="onSubmit()"
  autocomplete="on"
  errorTailor
>
  <div class="credit-card-form__form-group field__first_name">
    <mat-form-field class="full-width">
      <mat-label>First name</mat-label>
      <input
        formControlName="firstName"
        matInput
        type="text"
        [readonly]="disabledCardName"
        [controlErrorAnchor]="anchorFirstName"
      />
      <mat-error>
        <ng-template
          controlErrorAnchor
          #anchorFirstName="controlErrorAnchor"
        ></ng-template>
      </mat-error>
    </mat-form-field>
  </div>
  <div class="credit-card-form__form-group field__last_name">
    <mat-form-field class="full-width">
      <mat-label>Last name</mat-label>
      <input
        formControlName="lastName"
        type="text"
        [readonly]="disabledCardName"
        matInput
        [controlErrorAnchor]="anchorLastName"
      />
      <mat-error>
        <ng-template
          controlErrorAnchor
          #anchorLastName="controlErrorAnchor"
        ></ng-template>
      </mat-error>
    </mat-form-field>
  </div>
  <div class="credit-card-form__form-group">
    <fz-field-address
      formControlName="address"
      [required]="true"
      [controlErrorAnchor]="anchorFieldAddress"
      [touched]="cardForm.get('address')?.touched"
    >
      <label>Address</label>
      <mat-error>
        <ng-template
          controlErrorAnchor
          #anchorFieldAddress="controlErrorAnchor"
        ></ng-template>
      </mat-error>
    </fz-field-address>
  </div>
  <div
    class="credit-card-form__form-group card_number"
    *ngIf="this.type === 'CC'"
  >
    <mat-form-field class="full-width">
      <mat-label>Card Number</mat-label>
      <input
        formControlName="number"
        matInput
        [controlErrorAnchor]="anchorCardNumber"
        [placeholder]="getCardNumberPlaceholder()"
        [mask]="getCardNumberMask()"
        (change)="onCardNumberChange()"
        (paste)="onPaste($event)"
        inputmode="numeric"
        autocomplete="cc-number"
        id="cc-number"
        name="cc-number"
      />
      <div
        matTextSuffix
        *ngIf="getCardName"
        class="credit-card-icon"
        [ngClass]="getCardName"
      >
        <img src="/shared/img/credit-cards/{{ getCardName }}.svg" />
      </div>
      <mat-error>
        <ng-template
          controlErrorAnchor
          #anchorCardNumber="controlErrorAnchor"
        ></ng-template>
      </mat-error>
    </mat-form-field>
  </div>
  <div
    class="credit-card-form__form-group field_expiration_date"
    *ngIf="this.type === 'CC'"
  >
    <mat-form-field class="full-width">
      <mat-label>Expiration (Month/Year)</mat-label>
      <input
        formControlName="expiration"
        matInput
        [controlErrorAnchor]="anchorExpiration"
        placeholder="MM/YY"
        mask="M0/00"
        inputmode="numeric"
        pattern="^[0-9\/]*$"
        autocomplete="cc-exp"
        name="cc-exp"
        id="cc-exp"
      />
      <mat-error>
        <ng-template
          controlErrorAnchor
          #anchorExpiration="controlErrorAnchor"
        ></ng-template>
      </mat-error>
    </mat-form-field>
  </div>
  <div
    class="credit-card-form__form-group field_ccv"
    *ngIf="this.type === 'CC'"
  >
    <mat-form-field class="full-width">
      <mat-label>CVV <span class="hide-mobile">security code</span></mat-label>
      <input
        formControlName="cvv"
        matInput
        [controlErrorAnchor]="anchorCCV"
        [placeholder]="getCvvPlaceholder()"
        [mask]="getCvvMask()"
        inputmode="numeric"
        autocomplete="cc-csc"
        id="cc-csc"
        name="cc-csc"
      />
      <mat-error>
        <ng-template
          controlErrorAnchor
          #anchorCCV="controlErrorAnchor"
        ></ng-template>
      </mat-error>
    </mat-form-field>
  </div>
  <div class="credit-card-form__form-group short" *ngIf="this.type === 'ACH'">
    <mat-form-field class="full-width">
      <mat-label>Routing Number</mat-label>
      <input
        formControlName="routingNumber"
        matInput
        [controlErrorAnchor]="anchorCardNumber"
        placeholder="123456789"
        mask="000000000"
        inputmode="numeric"
        autocomplete="routing-number"
        name="routing-number"
        id="routing-number"
      />
      <mat-error>
        <ng-template
          controlErrorAnchor
          #anchorCardNumber="controlErrorAnchor"
        ></ng-template>
      </mat-error>
    </mat-form-field>
  </div>

  <div class="credit-card-form__form-group short" *ngIf="this.type === 'ACH'">
    <mat-form-field class="full-width">
      <mat-label>Account Number</mat-label>
      <input
        formControlName="accountNumber"
        matInput
        [controlErrorAnchor]="anchorAccountNumber"
        placeholder="1234xxxxx"
        mask="000000||00000099999999999"
        inputmode="numeric"
        autocomplete="account-number"
        name="account-number"
        id="account-number"
      />
      <mat-error>
        <ng-template
          controlErrorAnchor
          #anchorAccountNumber="controlErrorAnchor"
        ></ng-template>
      </mat-error>
    </mat-form-field>
  </div>

  <div class="credit-card-form__form-group short" *ngIf="this.type === 'ACH'">
    <mat-form-field class="full-width">
      <mat-label>Phone Number</mat-label>
      <input
        formControlName="phoneNumber"
        matInput
        [controlErrorAnchor]="anchorExpiration"
        placeholder="+1 (152) 254-1254"
        mask="(000) 000-0000"
        prefix="+1 "
        inputmode="tel"
        autocomplete="phone-number"
        name="phone-number"
        id="phone-number"
      />
      <mat-error>
        <ng-template
          controlErrorAnchor
          #anchorExpiration="controlErrorAnchor"
        ></ng-template>
      </mat-error>
    </mat-form-field>
  </div>

  <div
    class="credit-card-form__form-group actions"
    [class]="{ 'direction-row': !disableSecondaryAction }"
  >
    <button
      mat-flat-button
      color="primary"
      class="btn btn-success full-width fz-button--medium"
      type="submit"
      [class.mat-button-loading]="loading"
      [disabled]="loading"
    >
      {{ primaryActionName }}
    </button>
    <button
      mat-stroked-button
      color="primary"
      class="btn btn-success fz-button--medium full-width primary-color"
      type="button"
      (click)="onChangePaymentMethod()"
      *ngIf="!disableSecondaryAction"
    >
      {{ secondaryActionName }}
    </button>
  </div>
  <div class="credit-card-form__form-group" *ngIf="!disableSaveCard">
    <hr class="separator" />
    <mat-checkbox
      class="shipping-box"
      [color]="'primary'"
      formControlName="saveCreditCard"
      ><label class="save-payment-method"
        >Save my {{ getAccountLabel() }} details securely for future
        {{ withdraw ? 'withdrawals' : 'deposits' }}.</label
      ></mat-checkbox
    >
  </div>
  <div class="credit-card-form__form-group" *ngIf="disableSaveCard">
    <hr class="separator" />
    <label class="form-disclaimer mat-body-small"
      >We are storing your payment information while your player profile is
      verified. You can always remove any of your stored payment methods from
      your Z-Wallet at any point. However, for your convenience, it’s
      recommended to have at least one valid payment method linked to your
      Z-Wallet at any given time.</label
    >
  </div>
</form>
